import { AuthenticationService, HistoryService, HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { APPLICATION_ENDPOINTS } from '../constants/application-endpoints';
import { APPLICATION_ROUTES } from '../constants/application-routes';
import { TermsOfUseType } from '../constants/terms-of-use-type';

interface TermsOfUse {
  nrSeqTermo?: number;
}

interface TargetPair {
  parameters?: Record<string, unknown>,
  path: string,
}

interface RequiredConsent {
  check: RequiredConsentCheck
  content: RequiredConsentContent
}

interface RequiredConsentCheck {
  endpoint: TargetPair,
}

interface RequiredConsentContent {
  endpoint: TargetPair,
  route: TargetPair,
}

interface RequiredConsentCheckResult {
  consented: boolean,
  route?: TargetPair,
  sequence?: number,
}

const requiredConsents: Array<RequiredConsent> = [
  {
    check: {
      endpoint: {
        parameters: { termType: TermsOfUseType.TERM_OF_USE, },
        path: APPLICATION_ENDPOINTS.CHECK_TERMS_OF_USE,
      }
    },
    content: {
      endpoint: {
        parameters: { termType: TermsOfUseType.TERM_OF_USE, },
        path: APPLICATION_ENDPOINTS.GET_TERMS_OF_USE_SEQUENCE,
      },
      route: {
        parameters: { termType: TermsOfUseType.TERM_OF_USE, },
        path: APPLICATION_ROUTES.ASSIGN_TERMS_OF_USE,
      }
    },
  },
  {
    check: {
      endpoint: { path: APPLICATION_ENDPOINTS.CHECK_PRIVACY },
    },
    content: {
      endpoint: { path: APPLICATION_ENDPOINTS.GET_PRIVACY_SEQUENCE },
      route: { path: APPLICATION_ROUTES.ASSIGN_PRIVACY },
    },
  },
];

export default class ApplicationTermService {

  static hasSignedRequiredConsents(): Promise<void> {

    const requestConsent = (content: RequiredConsentContent): Promise<RequiredConsentCheckResult> => {
      return HttpService.get<TermsOfUse>(content.endpoint.path, content.endpoint.parameters)
        .then(response => ({ consented: false, route: content.route, sequence: response.body?.nrSeqTermo }));
    }

    const checkConsent = (endpoint: TargetPair): Promise<boolean> => {
      return HttpService.get<TermsOfUse>(endpoint.path, endpoint.parameters)
        .then(response => response.body?.nrSeqTermo != null)
    };

    const toCheckConsent = (requiredConsent: RequiredConsent): Promise<RequiredConsentCheckResult> => {
      return checkConsent(requiredConsent.check.endpoint)
        .then(consented => consented ? { consented } : requestConsent(requiredConsent.content ));
    }

    const hasSignedRequiredConsents = (results: Array<RequiredConsentCheckResult>): Promise<void> => {

      if (results.every(result => result.consented)) {
        return Promise.resolve();
      }

      const pendingConsent = results.find(result => !result.consented);
      if (pendingConsent && pendingConsent.route && pendingConsent.sequence) {
        HistoryService.push(pendingConsent.route?.path, { nrSeqTermo: pendingConsent.sequence, ...pendingConsent.route.parameters });
        return Promise.reject();
      }

      /**
       * TO-DO Refactor me.
       * Redirect to a error screen showing what is missing instead of should logout the user.
       */
      AuthenticationService.logout();
      return Promise.reject('Erro while checking required consents');
    }

    return Promise.all(requiredConsents.map(toCheckConsent))
      .then(hasSignedRequiredConsents);
  }
}
